import { createContext, useContext } from 'react';
import { AppProvider, useApp } from '@context/AppContext';
import { useFirebaseRoom } from '@hooks/useFirebaseRoom';
import LandingScreen from '@screens/LandingScreen';
import WhiteboardRoom from '@screens/WhiteboardRoom';

const FirebaseContext = createContext(null);
export const useFirebase = () => useContext(FirebaseContext);

const AuthUidContext = createContext(null);
export const useAuthUid = () => useContext(AuthUidContext);

function AppContent() {
  const { state, dispatch } = useApp();
  const firebase = useFirebaseRoom(dispatch);

  return (
    <FirebaseContext.Provider value={firebase}>
      {state.ui.screen === 'landing' ? <LandingScreen /> : <WhiteboardRoom />}
    </FirebaseContext.Provider>
  );
}

export default function App({ authUid }) {
  return (
    <AuthUidContext.Provider value={authUid}>
      <AppProvider>
        <AppContent />
      </AppProvider>
    </AuthUidContext.Provider>
  );
}
